import { EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { EventDetailed } from "../../models/events/event-detailed.model";

export const eventAdapter: EntityAdapter<EventDetailed> = createEntityAdapter<EventDetailed>({
    selectId: (x: EventDetailed) => x.eventID.toString() || x.eventLink,
    sortComparer: (a,b) => new Date(b.eventStart).getDate() - new Date(a.eventStart).getDate()
});